(function (profitEnvironment, $) {
    profitEnvironment.Init = function (pageTypeId, publicKey) {
        $('[data-pagetype-id]').val(pageTypeId);
        $('[data-public-key]').attr('placeholder', publicKey);
        $("#profitEnvironmentForm").on("submit", function (event) {
            let hasErrors = $("#HasErrors").val() === "True";
            const savePrompt = "Er zijn foutmeldingen opgetreden tijdens het openen van de omgeving. Het kan zijn dat niet alle velden (meer) gevuld zijn.\r\n\r\nWeet je zeker dat je de omgeving wil opslaan?"
            if (hasErrors && !window.confirm(savePrompt)) {
                event.preventDefault();
            }
        });

        $(document).on("click", "a[data-other-backoffice]", function (event) {
            event.preventDefault();

            let backofficeWindow = window.open($(this).attr("href"), "_blank");
            let intervalId = setInterval( function () {
                if (backofficeWindow.closed) {
                    globalCore.refreshTable({ gridId: "profitenvironmentsubscriptionsgrid" });
                    clearInterval(intervalId);
                }
            }, 500);
        });
    }

    profitEnvironment.onDeleteModalSuccess = function (result) {
        globalCore.onModalSuccess(result);
        window.location.href = window.location.pathname + window.location.search + "#profitenvironmentsubscriptions";
        window.location.reload();
    }

    /* Set change event handlers for employer and team dropdowns */
    profitEnvironment.InitEmployerTeamChangeHandlers = function () {
        $(document).on("change", "[data-employer-code]", function (evt) {
            $('[data-hidden-name]').val($(this).find(':selected').text());
        });
        $(document).on("change", "[data-team-code]", function (evt) {
            $('[data-hidden-team-name]').val($(this).find(':selected').text());
        });
    }

    profitEnvironment.EmployerTeamSelectList = function () {
        $("[data-employer-teams]").select2({
            dropdownParent: $('#modalcontainer'),
            width: 'resolve'
        });
    }

    profitEnvironment.InitPageTypeChangeHandlers = function () {
        $(document).on("change", "[data-pagetype-id]", function (evt) {
            $.ajax({
                url: '/ProfitEnvironment/PageType',
                dataType: 'json',
                data: {
                    clientKey: $('[data-client-key]').val(),
                    profitEnvironmentKey: $('[data-profitenvironment-key]').val(),
                    pageTypeId: $('[data-pagetype-id]').val(),
                },
                success: function (result) {
                    if (result === undefined || result === null) {
                        $('[data-public-key]').removeAttr('placeholder');
                        $('[data-private-key]').removeAttr('placeholder');
                    } else {
                        $('[data-public-key]').attr('placeholder', result?.publicKey)
                        $('[data-private-key]').attr('placeholder', 'Geheime sleutel')
                    }
                }
            });
        });
    }

    /* Toggle the Token / OAuth fields; hidden fields are cleared so both credential types are never posted together */
    profitEnvironment.InitAuthenticationTypeToggle = function () {
        let authenticationOptions = $("[data-authentication-options]");

        let show = function (authenticationType) {
            authenticationOptions.hide();
            authenticationOptions.filter("[data-authentication-options='" + authenticationType + "']").show();
        };

        $("[data-authenticationtype] input").on("change", function () {
            let authenticationType = $(this).val();
                                                                        
            authenticationOptions.not("[data-authentication-options='" + authenticationType + "']").find("input").val("");
            show(authenticationType);
        });

        show($("[data-authenticationtype] input:checked").val());
    }
}(window.profitEnvironment = window.profitEnvironment || {}, $));
